export function extractImageName(url: string): string {
  const parts = url.split('/');
  const lastPart = parts.pop() || '';
  const imageName = lastPart.split('.').slice(0, -1).join('.');
  return imageName;
}
